import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { ActiveScenarioList } from "@/components/scenarios/ActiveScenarioList";

export default function ScenariosActivesPage() {
  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
        <div>
          <div className="flex flex-wrap gap-2 mb-2">
            <Button variant="ghost" size="sm" asChild>
              <Link to="/scenarios" className="flex items-center gap-2">
                <ArrowLeft className="h-4 w-4" />
                Back to Scenarios
              </Link>
            </Button>
          </div>
          <h1 className="text-3xl font-bold bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
            Active Scenarios
          </h1>
          <p className="text-muted-foreground mt-1">
            Browse and manage active scenarios
          </p>
        </div>
      </div>
      <ActiveScenarioList />
    </div>
  );
}
